// extracted by mini-css-extract-plugin
export default {"cleaningSuggestionsSection":"CleaningSuggestionsSection_cleaningSuggestionsSection__3hr1f"};